import { render, staticRenderFns } from "./WxPaymentSuccessful.vue?vue&type=template&id=35a3fc56&scoped=true&"
import script from "./WxPaymentSuccessful.vue?vue&type=script&lang=js&"
export * from "./WxPaymentSuccessful.vue?vue&type=script&lang=js&"
import style0 from "./WxPaymentSuccessful.vue?vue&type=style&index=0&id=35a3fc56&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a3fc56",
  null
  
)

export default component.exports